module.exports = __webpack_public_path__ + "img/pile2.82dde6db.png";